import { Location } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable, of } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { CommonsConfigEnvironment, CONFIG_ENVIRONMENT } from '@mirage-projects/cw-models';

import { EntryPointConfig } from './entry-point-config';

/**
 * Service that manages the app's entry points
 */
@Injectable({
    providedIn: 'root',
})
export class EntryPointService {
    static SITE = 'site';
    static MAGNET = 'magnet';

    private entryPoints: EntryPointConfig[] = [];

    constructor(
        @Inject(CONFIG_ENVIRONMENT) private configEnvironment: CommonsConfigEnvironment,
        private http: HttpClient,
        private location: Location
    ) {}

    initEntryPoints(isSite: boolean): Observable<EntryPointConfig[] | undefined> {
        // TODO: change URL when is avaibled the service for get endpoints
        const appName = isSite ? EntryPointService.SITE : EntryPointService.MAGNET;
        const urlEntryPoint = this.location.prepareExternalUrl(`assets/entry-points/${appName}.json`);

        return this.http.get<EntryPointConfig[]>(urlEntryPoint).pipe(
            switchMap((data) => {
                this.setEntryPoints(data);
                return of(data);
            })
        );
    }

    setEntryPoints(entryPoints: EntryPointConfig[]): void {
        this.entryPoints = entryPoints;
    }

    getEntryPoint(resource: string, id?: string): string | null {
        const entryPointObj = this.entryPoints.find((e) => e.resource === resource);
        if (!entryPointObj) {
            return null;
        }

        if (id) {
            return `${entryPointObj?.entryPoint}${id}/`;
        } else {
            return entryPointObj?.entryPoint;
        }
    }

    getEntryPointsForCore(): any /* We can't type this*/ {
        const res = {} as any;
        this.entryPoints.forEach((element) => {
            res[element.resource] = element.entryPoint;
        });
        return res;
    }

    getBaseUrl(): string {
        const baseUrl = this.configEnvironment.port
            ? `${this.configEnvironment.baseURL}:${this.configEnvironment.port}`
            : this.configEnvironment.baseURL;
        return baseUrl;
    }

    getResource(resource: string, id?: string): string | null {
        const entryPoint = this.getEntryPoint(resource, id);
        if (!entryPoint) {
            return null;
        }
        const baseUrl = this.getBaseUrl();
        return baseUrl + entryPoint;
    }

    getEntryPoints(): EntryPointConfig[] {
        return this.entryPoints;
    }

    getPublicApiUrl(): string {
        return this.configEnvironment.publicApiUrl;
    }
}
